import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const CheckoutQuestions = ({ questions, answers, handleChange, darkMode }) => (
  <>
    {questions?.map((question) => (
      <FormGroup key={question?.id}>
        <Label
          className={`d-flex flex-wrap gap-1 align-items-center ${
            darkMode ? "normal-heading-dark" : "normal-heading"
          }`}
        >
          {question?.isMandatory && <span className="text-danger">*</span>}
          <span className="text-break">{question?.title}?</span>
        </Label>

        <Input
          type="textarea"
          value={answers[question?.id]?.answer || ""}
          required={question?.isMandatory}
          onChange={(event) => handleChange(event, question?.id)}
        />
      </FormGroup>
    ))}
  </>
);

export default CheckoutQuestions;
